import { render, staticRenderFns } from "./PromoItemsTableFromFile.vue?vue&type=template&id=4afbb8cc&scoped=true&"
import script from "./PromoItemsTableFromFile.vue?vue&type=script&lang=js&"
export * from "./PromoItemsTableFromFile.vue?vue&type=script&lang=js&"
import style0 from "./PromoItemsTableFromFile.vue?vue&type=style&index=0&id=4afbb8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afbb8cc",
  null
  
)

export default component.exports